export default "__VITE_ASSET__cJmBpYxP__"